export default __webpack_public_path__ + "static/media/ManagePatientProfile.0edd1dd3.svg";